import { defineStore } from 'pinia'

export enum MembershipActionType {
  FETCHING = 'fetching',
  FETCHED = 'fetched',
  FETCH_FAILED = 'fetch_failed',
  CREATING = 'creating',
  CREATED = 'created',
  CREATE_FAILED = 'create_failed',
  UPDATING = 'updating',
}

interface MembershipDetail {
  id: number,
  status: string,
  name: string,
  description: string,
  price: number,
  period: string,
  created_at: string
}

interface MembershipDetailState {
  package: {
    [key: string]: {
      action_type: MembershipActionType,
      action_message: string,
      package: MembershipDetail
    }
  }
}

export const usePackageDetailStore = defineStore('system.membership.detail', {
  state: (): MembershipDetailState => ({
    package: {},
  }),
  getters: {},
  actions: {
    async fetchPackage(id: number) {
      this.package[id] = {
        action_type: MembershipActionType.FETCHED,
        action_message: '',
        package: {id: 1, status: 'Ngưng hoạt động', name: 'Premium', description: '', price: 300000, period: '30 ngày', created_at: '2025-05-01 00:00:00'},
      }
    },
    async setPackage(id: number, membershipPackage: Object) {
      this.package[id] = {
        action_type: MembershipActionType.FETCHED,
        action_message: '',
        package: {...this.package[id].package, ...membershipPackage},
      }
    },
  },
})
